import { createAsyncThunk } from "@reduxjs/toolkit";
import { IFeedbackData, IFeedbackResponse } from "./types";
import { axiosInstance } from "@/resources/requestInfo";
import { feedbackRoutes } from "./routes";

export const fetchFeedback = createAsyncThunk<IFeedbackResponse, IFeedbackData>(
  "feedback/fetchFeedback",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(feedbackRoutes.FEEDBACK, data);
      
      return response.data.message;
    } catch (error: any) {
      return rejectWithValue(error.response.data.message);
    }
  }
);
